import {resolveBackground} from '#core/utils/color-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import EVENT_CARD_MARKETS_SLIDER from './event-card-markets-slider.palette-schema.yaml';

registerTileSchema(EVENT_CARD_MARKETS_SLIDER);

const PAGINATION_DOT_ITEM_BASE = {
    flexGrow: 0,
    flexBasis: 'auto',
    padding: '0',
};

export function generateEventCardMarketsSlider(TILE) {
    return {
        marketTitle: {
            truncate: true,
            container: {
                padding: '0 8px 4px 8px',
            },
        },
        paginationDots: {
            item: {
                unselected: {
                    style: {
                        base: {
                            ...PAGINATION_DOT_ITEM_BASE,
                            borderRadius: '50%',
                            minWidth: '6px',
                            minHeight: '6px',
                            width: '6px',
                            height: '6px',
                            ...resolveBackground(TILE.DOT_UNSELECTED_BG),
                        },
                    },
                },
                selected: {
                    style: {
                        base: {
                            ...PAGINATION_DOT_ITEM_BASE,
                            borderRadius: '9999px',
                            minWidth: '18px',
                            minHeight: '6px',
                            width: '18px',
                            height: '6px',
                            ...resolveBackground(TILE.DOT_SELECTED_BG),
                        },
                    },
                },
            },
        },
    };
}
